import React from "react";
import { Text, Pressable, Image } from "react-native";
import { store } from "../../store/store";
import { LinearGradient } from 'expo-linear-gradient';
import { ActiveTabControler } from "../services/subject-behaviour/CommonRxjsService";
import { isGuestTokenValid, getImagePath, isChemistStoreLoaded, isObjectNotEmpty } from "../services/CommonUtils";

import { ScreenRoute } from "../constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import TextStyle from "../../TextStyle";
import AppStyles from "../../AppStyles";
import Colors from "../constants/AppColors";

export const PrimaryCTA = (props) => {
    const key = props?.from ?? props.title
    const title = props?.title ?? props.text

    const viewStyle = props?.viewStyle ?? null

    const marginVertical = props?.marginVertical ?? 0
    const paddingVertical = props?.paddingVertical ?? 14
    const paddingHorizontal = props?.paddingHorizontal ?? null

    const disabled = props?.disabled ?? false
    const action = props?.action ?? props.onPress

    const marginAuto = props?.marginAuto ?? true

    let ctaWidth = props.width ?? AppTheme.appWidth - 32

    if (paddingHorizontal) ctaWidth = null

    var marginAutoStyle = null
    if (marginAuto) marginAutoStyle = { margin: 'auto' }

    return <Pressable key={key}
        onPress={action} disabled={disabled}>
        <LinearGradient colors={[disabled ? Colors.grey.disable : Colors.primary,
        disabled ? Colors.grey.disable : Colors.blue.darkBlue]}
            start={{ x: 0.0, y: 0.5 }} end={{ x: 1.0, y: 0.5 }}
            style={[{
                margin: 'auto', alignItems: 'center',
                marginVertical: marginVertical,
                paddingVertical: paddingVertical,
                paddingHorizontal: paddingHorizontal,
                width: ctaWidth, borderRadius: 12
            }, viewStyle]}><Text style={[TextStyle.text14xb, {
                color: "white", textAlign: 'center'
                // Replacing text with title.
            }]}>{title}</Text>
        </LinearGradient>
    </Pressable>
}

export const SecondaryCTA = (props) => {
    const key = props?.from ?? props.title
    const title = props?.title ?? props.text

    const viewStyle = props?.viewStyle ?? null

    const borderWidth = props?.borderWidth ?? 2

    let marginVertical = props.marginVertical ?? 0
    let paddingVertical = props.paddingVertical ?? 14
    let paddingHorizontal = props?.paddingHorizontal ?? null

    const marginAuto = props?.marginAuto ?? true

    let ctaWidth = props.width ?? AppTheme.appWidth - 32

    const textColor = props?.textColor ?? Colors.primary
    const borderColor = props?.borderColor ?? Colors.primary
    const backgroundColor = props.backgroundColor ?? Colors.white

    const disabled = props?.disabled ?? false
    const action = props?.action ?? props.onPress

    if (borderWidth)
        paddingVertical = paddingVertical - borderWidth

    if (paddingHorizontal) ctaWidth = null

    var marginAutoStyle = null
    if (marginAuto) marginAutoStyle = { margin: 'auto' }

    return <Pressable disabled={disabled} key={key}
        onPress={action} style={[AppStyles.borderView, {
            alignItems: 'center', borderWidth: borderWidth, marginVertical: marginVertical,
            paddingVertical: paddingVertical, paddingHorizontal: paddingHorizontal,
            width: ctaWidth, borderColor: borderColor, backgroundColor: backgroundColor
        }, viewStyle, marginAutoStyle]}><Text style={[TextStyle.text14xb, { color: textColor, textAlign: 'center' }]}>
            {title}</Text>
    </Pressable>
}

export const CommonCTA = (props) => {
    return <Pressable disabled={props.disabled}
        // Replacing onPress with action.
        onPress={props?.action ?? props.onPress}
        style={[{
            margin: 'auto', alignItems: 'center', borderRadius: 12,
            marginVertical: props.marginVertical ?? 0,
            paddingVertical: props.paddingVertical ?? 16,
            width: props.width ?? AppTheme.appWidth - 32,
            backgroundColor: props.backgroundColor ?? Colors.white
        }]}><Text style={[TextStyle.text14xb, {
            color: props?.textColor ?? Colors.primary,
            textAlign: 'center'
            // Replacing text with title.
        }]}>{props?.title ?? props.text}</Text>
    </Pressable>
}

export const CommonOrderNowCTA = (props) => {
    const ctaWidth = props?.width ?? 112

    function actionToPerform() {
        const reduxState = store.getState()
        let chemistStoreData = reduxState.pharmacyAllData
        const chemistStoreLoaded = isChemistStoreLoaded()
        if (chemistStoreLoaded) {
            if (chemistStoreData['spslEnabled'])
                props.navigation.navigate(ScreenRoute.search_deals)
            else props.navigation.navigate(ScreenRoute.search_medicine)
        } else {
            if (reduxState.isUserLogin || isGuestTokenValid()) {
                if (isObjectNotEmpty(reduxState.pharmacyAllData)) {
                    props.navigation.navigate(ScreenRoute.selected_pharmacy,
                        { selectedLocation: reduxState.selectedLocation })
                    global.windowScrollListPageYOffset = scrollY;
                } else if (reduxState.selectedLocation &&
                    isObjectNotEmpty(reduxState.selectedLocation)) {
                    props.navigation.navigate(ScreenRoute.list_pharmacy,
                        { selectedLocation: reduxState.selectedLocation })
                } else props.navigation.navigate(ScreenRoute.oms_detect_user_location, {})
            }
        }

    }
    return <PrimaryCTA action={() => actionToPerform()}
        width={ctaWidth} text={'Order now'}
        paddingVertical={8} marginVertical={24} />
}

export const CommonIconCTA = (props) => {
    const key = props.title
    const title = props.title
    const icon = props?.icon
    const iconPath = icon ? '/images/icons/' + icon : props?.iconPath

    const disabled = props?.disabled ?? false
    const action = props?.action ?? props.onPress

    const marginVertical = props.marginVertical ?? 0
    const paddingVertical = props.paddingVertical ?? 14

    const borderWidth = props?.borderWidth ?? 0
    const borderRadius = props?.borderRadius ?? 12

    const imageTextGap = props?.imageTextGap ?? 4

    const titleColor = props?.titleColor ?? Colors.primary
    const borderColor = props?.borderColor ?? Colors.primary
    const ctaBackgroundColor = props.backgroundColor ?? Colors.white

    const iconSize = props?.iconSize
    var iconWidth = props?.iconWidth
    var iconHeight = props?.iconHeight

    const paddingHorizontal = props?.paddingHorizontal ?? null
    var ctaWidth = props.width ?? AppTheme.appWidth - 32

    if (paddingHorizontal) ctaWidth = null
    if (iconSize) { iconHeight = iconSize; iconWidth = iconSize }

    return <Pressable key={key}
        disabled={disabled} onPress={action}
        style={[AppStyles.flexRowCenter, {
            borderRadius: borderRadius, borderWidth: borderWidth,
            alignItems: 'center', marginVertical: marginVertical,
            paddingHorizontal: paddingHorizontal, paddingVertical: paddingVertical,
            width: ctaWidth, borderColor: borderColor, backgroundColor: ctaBackgroundColor
        }]}>
        <Image style={{ height: iconHeight, width: iconWidth, marginRight: imageTextGap }}
            source={{ uri: getImagePath(iconPath) }}></Image>
        <Text style={[TextStyle.text14xb, {
            textAlign: 'center', color: titleColor
        }]}>{title}</Text>
    </Pressable>
}